module.exports = __webpack_public_path__ + "img/749f482.jpg";